import axios from '../axios'
// 单独导出
export const login = (data) => {
  return axios({
    url: '/console/user/login',
    method: 'POST',
    data: data
  })
}
// 登出
export const logout = () => {
  return axios({
    url: '/logout',
    method: 'get'
  })
}
// 修改密码
export const changePASS = (data) => {
  return axios({
    url: '/console/user/update_password',
    method: 'POST',
    data
  })
}
//获取待接入工单数量
export const toJoinCount = (data) => {
  return axios({
    url: 'work_order_board/to_be_join/count',
    method: 'GET',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/login.js